
import { useParams } from "react-router-dom";
import { stories } from "../data/stories";
import { Header } from "../components/Header";
import { Story } from "../data/story-template";

const StoryPage = () => {
  const { id } = useParams();
  const story = stories.find(s => s.id === id) as Story | undefined;

  if (!story) {
    return (
      <div>
        <Header />
        <div className="container mx-auto px-4 py-8">
          <h1 className="text-2xl font-bold">Story not found</h1>
        </div>
      </div>
    );
  }

  const formatText = (text: string) => {
    // First replace _text_ or *text* with italicized text
    let formattedText = text.replace(/[_*](.*?)[_*]/g, '<em>$1</em>');
    
    // Then replace ^text^ with superscript text
    formattedText = formattedText.replace(/\^(.*?)\^/g, '<sup>$1</sup>');
    
    return formattedText;
  };

  return (
    <div>
      <Header />
      <article className="container mx-auto px-4 py-8 max-w-2xl">
        <header className="mb-8">
          <h1 className="text-4xl font-bold mb-4 text-story-text">{story.title}</h1>
          <div className="flex items-center justify-between text-gray-600 mb-6">
            <span>{story.author}</span>
            <span>{story.date}</span>
          </div>
        </header>
        <div className="prose prose-lg max-w-none">
          {story.image && (
            <img 
              src={story.image} 
              alt="Story header image"
              className="float-right ml-4 mb-4 w-1/3 rounded-lg shadow-lg"
            />
          )}
          {story.content.split('\n').map((paragraph, index) => (
            <p 
              key={index} 
              className={paragraph.trim() === '***' ? 'text-center' : ''}
              dangerouslySetInnerHTML={{ __html: formatText(paragraph) }}
            />
          ))}
        </div>
      </article>
    </div>
  );
};

export default StoryPage;
